/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  minDateTime: null,
  maxDateTime: new Date(),
  selectedDateTime: '',
  isDateTimeModalShowing: false,
  timelineStartTime: null,
  timelineEndTime: null,
};

const getters = {
  selectedDateTime: state => state.selectedDateTime,
  isDateTimeModalShowing: state => state.isDateTimeModalShowing,
  isLive: state => state.selectedDateTime.length === 0,
  timelineStartTime: state => state.timelineStartTime,
  timelineEndTime: state => state.timelineEndTime,
};

const mutations = {
  setSelectedDateTime(state, isoString) {
    state.selectedDateTime = isoString;
  },
  setDateTimeModal(state, boolean) {
    state.isDateTimeModalShowing = boolean;
  },
  setTimelineStartTime(state, dateTime) {
    // @dateTime Date()
    state.timelineStartTime = dateTime;
  },
  setTimelineEndTime(state, dateTime) {
    // @dateTime Date()
    state.timelineStartTime = dateTime;
  },
  setMinDateTime(state, dateTime) {
    // @dateTime Date()
    state.minDateTime = dateTime;
  },
  setMaxDateTime(state, dateTime) {
    // @dateTime Date()
    state.maxDateTime = dateTime;
  },
};

const actions = {
  setSelectedDateTime({ commit }, isoString) {
    commit('setSelectedDateTime', isoString);
  },
  hideDateTimeModal({ commit }) {
    commit('setDateTimeModal', false);
  },
  showDateTimeModal({ commit }) {
    commit('setDateTimeModal', true);
  },
  goLive({ commit }) {
    commit('setSelectedDateTime', '');
  },
  setTimelineStartTime({ commit }, dateTime) {
    // @dateTime Date()
    commit('setTimelineStartTime', dateTime);
  },
  setTimelineEndTime({ commit }, dateTime) {
    // @dateTime Date()
    commit('setTimelineEndTime', dateTime);
  },
  setMinDateTime({ commit }, dateTime) {
    commit('setMinDateTime', dateTime);
  },
  setMaxDateTime({ commit }, dateTime) {
    commit('setMaxDateTime', dateTime);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
